import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { apiAddInfo } from '../../request/api';
import { Input, message } from 'antd';

interface AddManagementProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}

interface invoiceInfo {
    invoicePhone: string;
    invoiceBank: string;
    invoiceAddress: string;
    invoiceIdentification: string;
    invoiceHeader: string;
    bankCardNumber: string;
}

const AddManagement: React.FC<AddManagementProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [messageApi, contextHolder] = message.useMessage();

    const [invoiceInfo, setInvoiceInfo] = useState<invoiceInfo>({
        invoicePhone: '',
        invoiceBank: '',
        invoiceAddress: '',
        invoiceIdentification: '',
        invoiceHeader: '',
        bankCardNumber: '',
    });

    const [errors, setErrors] = useState<{
        invoiceHeader: string;
        invoiceIdentification: string;
        invoiceAddress: string;
        invoicePhone: string;
        invoiceBank: string;
        bankCardNumber: string;
    }>({
        invoiceHeader: '',
        invoiceIdentification: '',
        invoiceAddress: '',
        invoicePhone: '',
        invoiceBank: '',
        bankCardNumber: '',
    });

    const goBack = () => {
        handleViewChange('manageinvoices');
    };

    const handleInputChange = (field: keyof invoiceInfo) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInvoiceInfo({
            ...invoiceInfo,
            [field]: value,
        });

        // Clear error for the specific field when typing
        setErrors({
            ...errors,
            [field]: '',
        });
    };

    const validateInputs = () => {
        let newErrors: typeof errors = {
            invoiceHeader: '',
            invoiceIdentification: '',
            invoiceAddress: '',
            invoicePhone: '',
            invoiceBank: '',
            bankCardNumber: '',
        };

        if (!invoiceInfo.invoiceHeader) newErrors.invoiceHeader = '请输入抬头';
        if (!invoiceInfo.invoiceIdentification) newErrors.invoiceIdentification = '请输入纳税人识别号';
        if (!invoiceInfo.invoiceAddress) newErrors.invoiceAddress = '请输入企业地址';
        if (!invoiceInfo.invoicePhone) newErrors.invoicePhone = '请输入联系电话';
        if (!invoiceInfo.invoiceBank) newErrors.invoiceBank = '请输入开户行';
        if (!invoiceInfo.bankCardNumber) newErrors.bankCardNumber = '请输入企业账号';

        setErrors(newErrors);

        // Check if there are no errors
        return Object.values(newErrors).every((error) => error === '');
    };

    const addInvoiceInfo = () => {
        if (validateInputs()) {
            apiAddInfo({
                tid: '809BB53916314B70AE9F79EA842C5D42',
                invoicePhone: invoiceInfo.invoicePhone,
                invoiceBank: invoiceInfo.invoiceBank,
                invoiceAddress: invoiceInfo.invoiceAddress,
                invoiceIdentification: invoiceInfo.invoiceIdentification,
                invoiceHeader: invoiceInfo.invoiceHeader,
                bankCardNumber: invoiceInfo.bankCardNumber,
            }).then((res) => {
                messageApi.open({
                    type: 'success',
                    content: '添加成功',
                });
                setTimeout(() => {
                    handleViewChange('manageinvoices');
                }, 2000);
            })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    return (
        <div className="AddManagement">
            {contextHolder}
            <div className="detail-back" style={{ color: themeColor }}>
                <ArrowLeftOutlined onClick={goBack} />
                <div className="detail-back-right" onClick={goBack}>
                    返回
                </div>
            </div>
            <div className="addmanagement-content">
                <div className="addmanagement-left">
                    <p>抬头：</p>
                    <p>纳税人识别号：</p>
                    <p>企业地址：</p>
                    <p>联系电话：</p>
                    <p>开户行：</p>
                    <p>企业账号：</p>
                </div>
                <div className="addmanagement-right">
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.invoiceHeader}
                            placeholder="请输入"
                            onChange={handleInputChange('invoiceHeader')}
                        />
                        {errors.invoiceHeader && (
                            <div className='management-input'>
                                {errors.invoiceHeader}
                            </div>
                        )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.invoiceIdentification}
                            placeholder="请输入"
                            onChange={handleInputChange('invoiceIdentification')}
                        />
                        {errors.invoiceIdentification && (
                            <div className='management-input'>
                                {errors.invoiceIdentification}
                            </div>
                        )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.invoiceAddress}
                            placeholder="请输入"
                            onChange={handleInputChange('invoiceAddress')}
                        />
                        {errors.invoiceAddress && (
                            <div className='management-input'>
                                {errors.invoiceAddress}
                            </div>
                        )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.invoicePhone}
                            placeholder="请输入"
                            onChange={handleInputChange('invoicePhone')}
                        />
                        {errors.invoicePhone && (
                            <div className='management-input'>
                                {errors.invoicePhone}
                            </div>
                        )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.invoiceBank}
                            placeholder="请输入"
                            onChange={handleInputChange('invoiceBank')}
                        />
                        {errors.invoiceBank && (
                            <div className='management-input'>
                                {errors.invoiceBank}
                            </div>
                        )}
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                        <Input
                            type="text"
                            value={invoiceInfo.bankCardNumber}
                            placeholder="请输入"
                            onChange={handleInputChange('bankCardNumber')}
                        />
                        {errors.bankCardNumber && (
                            <div className='management-input'>
                                {errors.bankCardNumber}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <button className="pay-button" onClick={addInvoiceInfo} style={{ marginTop: '20px' }}>
                确认
            </button>
        </div>
    );
};

export default AddManagement;